module.exports = __webpack_public_path__ + "img/group-10.04c6cb42.svg";